import * as _ from 'lodash'
import * as React from 'react'

interface IMaterialIconProps extends React.HTMLAttributes<HTMLElement> {
  icon: string
  fixedWidth?: boolean
  muted?: boolean
  color?: 'blue' | 'orange' | 'yellow' | 'green'
  spin?: boolean
}

export class MaterialIcon extends React.Component<IMaterialIconProps, {}> {
  getBtnClasses() {
    const classes = ['material-icons']
    const { fixedWidth, muted, color, spin } = this.props

    const addClassifTrue = (bool: boolean | undefined, className: string) => {
      if (bool) {
        classes.push(className)
      }
    }

    if (typeof this.props.className === 'string') {
      classes.push(this.props.className)
    }

    addClassifTrue(fixedWidth, 'material-icons-fw')
    addClassifTrue(muted, 'icon-muted')
    addClassifTrue(spin, 'fa-spin')

    if (!muted) {
      addClassifTrue(!!color, `icon-${color}`)
    }

    return classes.join(' ')
  }

  render() {
    const props = _.clone(this.props) as IMaterialIconProps
    delete props.className
    delete props.icon
    delete props.fixedWidth
    delete props.muted
    delete props.color

    return (
      <i className={this.getBtnClasses()} {...props}>
        {this.props.icon}
      </i>
    )
  }
}
